import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, fill, outline, gradient }) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M14.4178 7.69545C12.7878 3.34545 10.2178 0.775455 6.43776 1.01545C1.54776 1.32545 -1.71224 8.39547 4.11775 17.4055C7.07775 21.9855 10.6378 22.7655 13.1278 21.9055C15.6178 21.0555 17.7078 16.4854 14.4178 7.69545Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M4.97773 12.1454C4.97773 12.1454 3.18773 6.66541 5.66773 5.20541C8.12773 3.75541 12.2977 7.22542 12.1877 16.9054"
        fill={`url(#${randomGradientId1})`}
      />
      <path
        d="M4.97765 12.1455C4.58765 11.2655 4.34765 10.3355 4.16765 9.37546C4.01765 8.41546 3.95765 7.40545 4.27765 6.39545C4.53765 5.36545 5.59765 4.45546 6.75765 4.43546C7.92765 4.41546 8.91765 5.04546 9.61765 5.77546C11.0176 7.30546 11.6977 9.24545 12.0377 11.1455C12.3877 13.0655 12.3877 15.0055 12.1877 16.9055C11.9977 14.9955 11.7377 13.1155 11.2777 11.3155C10.8077 9.52547 10.1076 7.74546 8.89765 6.46546C8.30765 5.82546 7.54765 5.37546 6.77765 5.37546C6.00765 5.36546 5.30765 5.87544 5.00765 6.66544C4.69765 7.45544 4.61766 8.40545 4.65766 9.33545C4.66766 10.2655 4.81765 11.2055 4.97765 12.1455Z"
        fill={outline}
      />
      <path
        d="M72.7679 7.69545C74.3979 3.34545 76.9679 0.775455 80.7479 1.01545C85.6379 1.32545 88.8979 8.39547 83.0679 17.4055C80.1079 21.9855 76.5479 22.7655 74.0579 21.9055C71.5679 21.0555 69.4679 16.4854 72.7679 7.69545Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M82.198 12.1454C82.198 12.1454 83.988 6.66541 81.508 5.20541C79.048 3.75541 74.878 7.22542 74.988 16.9054"
        fill={`url(#${randomGradientId2})`}
      />
      <path
        d="M82.1979 12.1455C82.3679 11.2055 82.5079 10.2654 82.5279 9.32545C82.5679 8.39545 82.4879 7.45546 82.1779 6.65546C81.8779 5.86546 81.1779 5.35545 80.4079 5.36545C79.6479 5.37545 78.8779 5.82545 78.2879 6.45545C77.0879 7.73545 76.3779 9.51546 75.9079 11.3055C75.4479 13.1155 75.1779 14.9955 74.9979 16.8955C74.7979 14.9955 74.7979 13.0454 75.1479 11.1354C75.4879 9.22544 76.1579 7.29545 77.5679 5.76545C78.2779 5.03545 79.2679 4.39545 80.4279 4.42545C81.5779 4.44545 82.6379 5.35544 82.9079 6.38544C83.2179 7.39544 83.1679 8.41546 83.0179 9.36546C82.8279 10.3355 82.5879 11.2655 82.1979 12.1455Z"
        fill={outline}
      />
      <defs>
        <radialGradient
          id={randomGradientId1}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.96705 9.40255) rotate(145.174) scale(4.88878 7.1754)"
        >
          <stop stopColor={gradient[0]} />
          <stop offset="1" stopColor={gradient[1]} />
        </radialGradient>
        <radialGradient
          id={randomGradientId2}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(77.0547 9.53639) rotate(34.8264) scale(4.88878 7.17539)"
        >
          <stop stopColor={gradient[0]} />
          <stop offset="1" stopColor={gradient[1]} />
        </radialGradient>
      </defs>
    </g>
  )
}
